// import React from 'react';
// import Modal from 'react-bootstrap/Modal';
// import modalCss from './modal.module.css';

// function CustomAlertModal({ show, handleClose, content, buttonLabel, submit, redirectUser, modalTitle }) {
//     const handleButtonClick = () => {
//         if(submit) {
//             submit();
//         }
//         handleClose();
//         if(redirectUser) {
//             redirectUser();
//         }
//     }

//   return (
//     <Modal className={modalCss.container} show={show} onHide={handleClose} size="l">
//       <Modal.Header closeButton>
//         <Modal.Title className={modalCss.title}>{modalTitle}</Modal.Title>
//       </Modal.Header>
//       <Modal.Body className={modalCss.body}>
//         {content}
//       </Modal.Body>
//       <Modal.Footer>
//         <button onClick={handleButtonClick}
//           className={modalCss.button}>
//             {buttonLabel}
//         </button>
//       </Modal.Footer>
//     </Modal>
//   );
// }

// export default CustomAlertModal;

import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import modalCss from './modal.module.css';

function CustomAlertModal({
  show,
  handleClose,
  content,
  buttonLabel = 'Send inn',
  submit,
  redirectUser,
  modalTitle,
  footerContent,
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const handleButtonClick = async () => {
    if (isSubmitting) return;

    setErrorMsg('');

    // Hvis du ikke sender inn "submit", oppfør deg som vanlig close
    if (!submit) {
      handleClose();
      if (redirectUser) redirectUser();
      return;
    }

    setIsSubmitting(true);

    try {
      // Viktig: await submit slik at vi ikke lukker før det faktisk er ferdig
      const result = await submit();

      // Hvis submit returnerer false, tolker vi det som "ikke lukk" (valgfritt)
      if (result === false) return;

      handleClose();
      if (redirectUser) redirectUser();
    } catch (err) {
      console.error(err);
      setErrorMsg('Noe gikk galt. Prøv igjen.');
      // behold modalen åpen
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      className={modalCss.container}
      show={show}
      onHide={() => {
        if (isSubmitting) return; // hindrer lukking midt i innsending
        handleClose();
      }}
      size="lg"
    >
      <Modal.Header closeButton={!isSubmitting}>
        <Modal.Title className={modalCss.title}>{modalTitle}</Modal.Title>
      </Modal.Header>

      <Modal.Body className={modalCss.body}>
        {content}
        {errorMsg && <div style={{ marginTop: 8 }}>{errorMsg}</div>}
      </Modal.Body>

      <Modal.Footer>
        {footerContent && <div style={{ marginBottom: 10 }}>{footerContent}</div>}
        <button
          onClick={handleButtonClick}
          className={modalCss.button}
          disabled={isSubmitting}
          style={{ opacity: isSubmitting ? 0.7 : 1 }}
        >
          {isSubmitting ? 'Sender…' : buttonLabel}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default CustomAlertModal;